module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/CategoryFeatures-056daa6c0b45aaf82d4f0c2de3a0c04d.png";